import React from "react";
import { Provider } from "react-redux";
import { HashRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { createHashHistory } from "history";
export const history = createHashHistory();
import { store, persistor } from "./store/store";
import App from "./App";

// import "bootstrap/dist/css/bootstrap.min.css";     
const Root = () => (
  <Provider store={store}>
    <HashRouter>
      <PersistGate persistor={persistor}>
        <App />
      </PersistGate>
    </HashRouter>
  </Provider>
);

export default Root;
